import React, { useState, ChangeEvent, useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormGroup,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import userProfile from '../../../../assets/images/userProfile.svg';
import profileDelete from '../../../../assets/images/profileDeleteIcon.svg';
import { useForm } from 'react-hook-form';
import { useAlert } from '../../../../components/Notification';
import CropComponent from '../../../../components/crop';
import { useHook as CustomerHook } from '../useHook';
import { useSelector } from 'react-redux';
import { UrlToBase } from '../../../../components/urlToBase64';
import Update_Mail from '../../../../assets/images/Update_Mail.svg';
import PersonalDetailPopup from '../../../../components/personalDetailPopup';
import Notification_Edit from '../../../../assets/images/Notification_Edit.svg';
import Update_Phone from '../../../../assets/images/Upadate_Phone.svg';
import Success_Update from '../../../../assets/images/Success_Popup_img.svg';

const PersonalDetails = () => {
  const {
    fetchCustomerInfo,
    updateCustomerInfo,
    updateInfoOTP,
    verifyInfoOTP,
  } = CustomerHook();
  const { customerInformation } = useSelector(
    (state: any) => state.profileManagement,
  );
  const [activeEditButton, setActiveButton] = useState(false);
  const [openMailDialog, setOpenMailDialog] = useState(false);
  const [openMobileDialog, setOpenMobileDialog] = useState(false);
  const [openMobileVerifyDialog, setOpenMobileVerifyDialog] = useState(false);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [updateMobileNumber, setUpdateMobileNumber] = useState('');
  const [timerCount, setTimerCount] = useState(false);
  const [uploadError, setUploadError] = useState('');

  const showAlert = useAlert();
  const {
    register,
    formState: { errors },
    handleSubmit,
    clearErrors,
    setValue,
  } = useForm();

  // Set field values
  const customerDetailsFormValue = () => {
    if (customerInformation) {
      setValue('firstname', customerInformation.firstName || '');
      setValue('lastname', customerInformation.lastName || '');
      setValue('countrycode', '+91');
      setValue('mobilenumber', customerInformation.mobileNo || '');
      setValue('email', customerInformation.email || '');
      setValue('address', customerInformation.address || '');
      const imageUrl = customerInformation?.image;
      if (imageUrl) {
        UrlToBase(imageUrl)
          .then((base64String) => {
            setCroppedImages(base64String);
          })
          .catch((error) => console.error(error));
      }
      clearErrors();
    }
  };
  useEffect(() => {
    customerDetailsFormValue();
  }, [customerInformation, setValue]);

  const [imageString, setImageString]: [
    string,
    React.Dispatch<React.SetStateAction<string>>,
  ] = useState('');
  const [profileError, setProfileError] = useState('');
  const [croppedImage, setCroppedImages] = useState<string | null>(null);
  const [opencrop, setOpenCrop] = useState(false);

  //handleChange Profile image
  const handleFileChange = async (e: ChangeEvent<HTMLInputElement>) => {
    const file: File | null = e.target.files ? e.target.files[0] : null;

    if (file && validateImage(file, setProfileError)) {
      setProfileError('');

      await toBase64(file)
        .then((base64String) => {
          setImageString(base64String as string);
          setCroppedImages(base64String as string);
          setOpenCrop(true);
        })
        .catch(() => {
          setImageString('');
          setCroppedImages('');
          showAlert(`Failed to Upload Image.`, 'error');
          setOpenCrop(false);
        });
    }
    editButtonActive();
  };

  const validateImage = (
    file: File,
    setProfileError: (error: string) => void,
  ): boolean => {
    const allowedTypes: string[] = ['image/jpeg', 'image/png', 'image/gif'];
    const maxFileSize: number = 1024 * 1024; // 1MB

    if (!allowedTypes.includes(file.type)) {
      setProfileError('Please select a JPG, GIF, or PNG file.');
      return false;
    }

    if (file.size > maxFileSize) {
      setProfileError('File size exceeds the 1MB limit.');
      return false;
    }

    return true;
  };

  const handleClosePopup = () => {
    setOpenMailDialog(false);
  };
  const handleMailVerify = (data: any) => {
    console.log(data);
  };
  const mailPopupProps = {
    open: openMailDialog,
    handleClose: handleClosePopup,
    handleSubmit: handleMailVerify,
    title: 'Email',
    contentHeading: 'Are you sure, you want to change your email id?',
    contentSubHeading: customerInformation.email || '',
    btnText: 'Verify',
    imgURL: Update_Mail,
    nameData: customerInformation.email || '',
  };

  const handleCloseMobilePopup = () => {
    setOpenMobileDialog(false);
    setTimerCount(false);
  };
  const handleMobileVerify = async (data: string) => {
    setUpdateMobileNumber(data);
    try {
      const res = await updateInfoOTP({ mobileNo: data });
      if (res) {
        setTimerCount(true);
        setOpenMobileVerifyDialog(true);
      }
    } catch (error) {
      console.error('Error verifying mobile:', error);
      setTimerCount(false);
    }
  };

  const mobilePopupProps = {
    open: openMobileDialog,
    handleClose: handleCloseMobilePopup,
    handleSubmit: handleMobileVerify,
    title: 'Mobile Number',
    contentHeading: 'Are you sure, you want to change your contact number?',
    contentSubHeading: customerInformation?.mobileNo || '',
    btnText: 'Verify',
    imgURL: Update_Phone,
    nameData: customerInformation?.mobileNo || '',
  };

  //updateMobilepopup
  const handleCloseMobileVerifyPopup = () => {
    setOpenMobileVerifyDialog(false);
  };
  const handleMobileProceed = async (data: string) => {
    try {
      const res = await verifyInfoOTP({ otp: data });
      if (res) {
        setOpenMobileVerifyDialog(false);
        setOpenSuccessDialog(true);
      }
    } catch (error) {
      console.error('Error verifying OTP:', error);
    }
  };

  //handleResendOTP
  const handleResendOTP = () => {
    setTimerCount(false);
    handleMobileVerify(updateMobileNumber);
  };
  const mobileVerifyPopupProps = {
    open: openMobileVerifyDialog,
    handleClose: handleCloseMobileVerifyPopup,
    handleSubmit: handleMobileProceed,
    title: 'Mobile Number',
    contentHeading: (
      <>
        Enter the verification code sent on <br /> +1(91)*********
        {updateMobileNumber?.slice(6, 10)}.
      </>
    ),
    btnText: 'Verify & Proceed',
    imgURL: Update_Phone,
    timerCount: timerCount,
    handleResendOTP: handleResendOTP,
  };

  //success verify popup
  const handleCloseSuccessPopup = () => {
    setOpenSuccessDialog(false);
  };

  const toBase64 = (file: Blob) =>
    new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        if (typeof reader.result === 'string') {
          resolve(reader.result);
        } else {
          reject(new Error('Failed to read file as Data URL'));
        }
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  //delete profile image
  const handleDeleteImage = () => {
    setImageString('');
    setCroppedImages('');
    const uploadInput = document.getElementById(
      'upload-button',
    ) as HTMLInputElement;
    if (uploadInput) {
      uploadInput.value = '';
    }
    editButtonActive();
    setUploadError('');
  };

  //crop image
  const handleCropComplete = (croppedImage: string) => {
    setCroppedImages(croppedImage);
    setOpenCrop(false);
    setUploadError('');
  };

  //submit personalDetails
  const hadleSubmitPersonalDetails = async (data: any) => {
    if (opencrop) {
      setUploadError('Please upload the image');
    } else {
      const imageType = croppedImage?.substring(11, croppedImage?.indexOf(';'));
      const imageWithoutPrefix = croppedImage?.substring(
        croppedImage?.indexOf(',') + 1,
      );
      const payload = {
        customerID: customerInformation?.customerID,
        firstName: data?.firstname,
        lastName: data?.lastname,
        mobileNo: data?.mobilenumber,
        email: data?.email,
        address: data?.address,
        avatar: imageWithoutPrefix ? imageWithoutPrefix : '',
        ext: imageType ? imageType : '',
      };
      await updateCustomerInfo(payload);
      await fetchCustomerInfo();
      setActiveButton(false);
    }
  };

  //assign mobilenumber
  const handleMobileNumberChange = (event: { target: any; type?: any }) => {
    const inputValue = event.target.value.replace(/\D/g, '');
    event.target.value = inputValue;
    // Update form state with the cleaned value
    register('mobilenumber').onChange(event);
    editButtonActive();
  };

  //remove country code error
  const handleCountryCodeChange = (event: { target: { value: any } }) => {
    if (event.target.value) {
      clearErrors('countrycode');
    }
    editButtonActive();
  };

  // Utility function to safely get the error message
  const getErrorMessage = (error: any) => {
    if (!error) return '';
    if (typeof error?.message === 'string') return error.message;
    return 'Invalid input';
  };

  //buttonActive
  const editButtonActive = (fieldName?: any) => {
    setActiveButton(true);
    if (fieldName) {
      clearErrors(fieldName);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(hadleSubmitPersonalDetails)}>
        <section className="personal_details">
          <div className="personal_details_card">
            <div className="personal_details_card_lable_field">
              <h4>Name</h4>
              <h5>Will appear on profile and other communications</h5>
            </div>
            <div className="personal_details_card_input_field">
              <div className="personal_details_card_double-input_field">
                <div>
                  <TextField
                    variant="outlined"
                    fullWidth
                    {...register('firstname', {
                      required: 'First Name is required',
                      validate: (value) =>
                        value.trim() !== '' || 'First Name is required',
                    })}
                    onChange={() => editButtonActive('firstname')}
                    error={errors.firstname ? true : false}
                  />
                  {errors.firstname && (
                    <Typography
                      variant="body2"
                      className="personal_details_card_input_field-contact-error"
                    >
                      {getErrorMessage(errors?.firstname)}
                    </Typography>
                  )}
                </div>

                <div>
                  <TextField
                    variant="outlined"
                    fullWidth
                    {...register('lastname', {
                      required: 'Last Name is required',
                      validate: (value) =>
                        value.trim() !== '' || 'Last Name is required',
                    })}
                    error={errors.lastname ? true : false}
                    onChange={() => editButtonActive('lastname')}
                  />
                  {errors.lastname && (
                    <Typography
                      variant="body2"
                      className="personal_details_card_input_field-contact-error"
                    >
                      {getErrorMessage(errors?.lastname)}
                    </Typography>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="personal_details_card">
            <div className="personal_details_card_lable_field">
              <h4>Profile Picture</h4>
            </div>
            <div className="personal_details_card_input_field">
              <div className="create_user_profile-container">
                <div className="create_user_profile">
                  <div>
                    {croppedImage ? (
                      <img src={croppedImage} width={72} alt="User Profile" />
                    ) : (
                      <img src={userProfile} width={72} alt="User Profile" />
                    )}
                  </div>
                  <div>
                    <label
                      // variant="outlined"
                      // component="label"
                      htmlFor="upload-button"
                      className="custom-file-upload"
                    >
                      Change
                    </label>
                    <input
                      type="file"
                      accept="image/*"
                      id="upload-button"
                      onChange={(e) => handleFileChange(e)}
                    />
                  </div>
                  <div className="imageformat">
                    <p>JPG, GIF, or PNG. 1MB Max.</p>
                  </div>
                </div>
                {croppedImage && (
                  <Button
                    className="create_user_profile-delete"
                    onClick={() => handleDeleteImage()}
                  >
                    <img src={profileDelete} width={44} alt="delete icon" />
                  </Button>
                )}
              </div>
              {profileError && (
                <span className="text-danger">{profileError}</span>
              )}
              {opencrop && croppedImage && (
                <CropComponent
                  srce={croppedImage}
                  onCropComplete={handleCropComplete}
                  uploadError={uploadError}
                />
              )}
            </div>
          </div>

          <div className="personal_details_card">
            <div className="personal_details_card_lable_field">
              <h4>Contact Number</h4>
              <div className="personal_details_card_lable_edit-field">
                <h5>Will appear on profile and other communications</h5>
                {/* <Button onClick={() => setOpenMobileDialog(true)}>
                  <img src={Notification_Edit} alt="Notification Edit" />
                </Button> */}
              </div>
            </div>
            <div className="personal_details_card_input_field">
              <FormGroup>
                <div className="personal_details_card_input_field-contact">
                  <Select
                    className="form-countrycode"
                    {...register('countrycode', {
                      required: 'Country Code is required',
                    })}
                    variant="outlined"
                    error={errors.countrycode ? true : false}
                    onChange={handleCountryCodeChange}
                    defaultValue={'+91'}
                    disabled
                  >
                    <MenuItem value="+91">+91</MenuItem>
                  </Select>
                  <TextField
                    fullWidth
                    {...register('mobilenumber', {
                      required: 'Mobile Number is required',
                      pattern: {
                        value: /^[0-9]{10}$/,
                        message: 'Phone number must be 10 digits',
                      },
                    })}
                    inputProps={{
                      maxLength: 10,
                    }}
                    onChange={handleMobileNumberChange}
                    variant="outlined"
                    error={errors.mobilenumber ? true : false}
                    disabled
                  />
                  <Button
                    className="personal_details_input_edit-btn"
                    onClick={() => setOpenMobileDialog(true)}
                  >
                    Edit
                  </Button>
                </div>
                {errors.mobilenumber && (
                  <Typography
                    variant="body2"
                    className="personal_details_card_input_field-contact-error"
                  >
                    {getErrorMessage(errors?.mobilenumber)}
                  </Typography>
                )}
                {!errors.mobilenumber && errors.countrycode && (
                  <Typography
                    variant="body2"
                    className="personal_details_card_input_field-contact-error"
                  >
                    {getErrorMessage(errors?.countrycode)}
                  </Typography>
                )}
              </FormGroup>
            </div>
          </div>

          <div className="personal_details_card">
            <div className="personal_details_card_lable_field">
              <h4> Email</h4>
              <div className="personal_details_card_lable_edit-field">
                <h5>Enter your email for reset password or forgot password</h5>
                {/* <Button onClick={() => setOpenMailDialog(true)}>
                  <img src={Notification_Edit} alt="Notification Edit" />
                </Button> */}
              </div>
            </div>
            <div className="personal_details_card_input_field">
              <div className="personal_details_card_input_field-contact">
                <TextField
                  variant="outlined"
                  fullWidth
                  {...register('email', {
                    required: 'email is required',
                    pattern: {
                      value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                      message: 'Invalid email address',
                    },
                  })}
                  error={errors.email ? true : false}
                  onChange={() => editButtonActive('email')}
                  disabled
                />
                <Button
                  className="personal_details_input_edit-btn"
                  onClick={() => setOpenMailDialog(true)}
                >
                  Edit
                </Button>
              </div>
              {errors.email && (
                <Typography
                  variant="body2"
                  className="personal_details_card_input_field-contact-error"
                >
                  {getErrorMessage(errors?.email)}
                </Typography>
              )}
            </div>
          </div>

          <div className="personal_details_card">
            <div className="personal_details_card_lable_field">
              <h4>Address</h4>
            </div>
            <div className="personal_details_card_input_field">
              <TextField
                variant="outlined"
                fullWidth
                {...register('address')}
                error={errors.address ? true : false}
                onChange={() => editButtonActive('address')}
              />
              {errors.address && (
                <Typography
                  variant="body2"
                  className="personal_details_card_input_field-contact-error"
                >
                  {getErrorMessage(errors?.address)}
                </Typography>
              )}
            </div>
          </div>

          <div className="personal_details_card_action">
            <Button
              className="personal_details_card_action-edit"
              onClick={customerDetailsFormValue}
            >
              Cancel
            </Button>
            <Button
              className={
                activeEditButton
                  ? 'personal_details_card_action-save'
                  : 'personal_details_card_action-save disable_button_background'
              }
              type="submit"
              disabled={!activeEditButton}
            >
              Save
            </Button>
          </div>
        </section>
      </form>
      <PersonalDetailPopup {...mailPopupProps} />
      <PersonalDetailPopup {...mobilePopupProps} />
      <PersonalDetailPopup {...mobileVerifyPopupProps} />
      <Dialog
        className="renew-popup"
        open={openSuccessDialog}
        onClose={handleCloseSuccessPopup}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogContent className="renew_dialog-content">
          <div className="update_success_dialog-content">
            <img src={Success_Update} alt="Success_Update" />
            <div>
              <h4>successfully Verify?</h4>
              <h5>
                Your contact number +91 {customerInformation?.mobileNo || ''}{' '}
                <br /> updated successfully.
              </h5>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <div className="update_success_dialog_btn">
            <Button onClick={handleCloseSuccessPopup}>Done</Button>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PersonalDetails;
